export const birthDate18YearsValidation = (value: string): boolean => {
  if (!value) return false;

  const birthDateObj = new Date(value);

  if (isNaN(birthDateObj.getTime())) return false;

  const today = new Date();

  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDifference = today.getMonth() - birthDateObj.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDateObj.getDate())
  ) {
    age--;
  }

  return age >= 18;
};
